<template>
    <!--门店绑定记录-->
    <div class="page-wrap">
        <div class="page-body">
            <div class="search-box">
                <el-input v-model="formData.keyword" placeholder="手机号/拼音首字母/姓名" style="width: 300px" @keypress.native="e => {if(e.charCode === 13) loadListData();}" />&nbsp;&nbsp;
                <ChainStoreSelect v-model="formData.search_store_id" />&nbsp;&nbsp;
                <el-button type="primary" @click="loadListData">搜索</el-button>
            </div>
            <div class="list-box">
                <el-table :data="listData" style="width: 100%">
                    <el-table-column prop="create_datetime" label="绑定时间" />
                    <el-table-column prop="name" label="姓名" />
                    <el-table-column prop="mobile" label="联系电话" />
                    <el-table-column prop="wechat_name" label="绑定时微信昵称" />
                    <el-table-column prop="store_name" label="所属门店" />
                </el-table>
            </div>
            <div class="page-box">
                <el-pagination
                        @size-change="pageSizeChange"
                        @current-change="pageCurrentChange"
                        :current-page="page.nowPage"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import RightTop from "@/model/RightTop";
    import ChainStoreSelect from "@/model/Chain/ChainStoreSelect";
    export default {
        name: "ChainStoreBindHistory",
        components: {ChainStoreSelect, RightTop},
        mounted: function () {
            this.loadListData();
        },
        data: () => ({
            formData: {
                keyword: "",
                search_store_id: "",
            },
            listData: [],
            page: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
        }),
        methods: {
            //每页显示数量变化
            pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadListData();
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadListData();
            }
            //加载数据
            ,loadListData: function () {
                let postData = {
                    keyword: this.formData.keyword,
                    search_store_id: this.formData.search_store_id,
                };
                obj.postData("chain_history/get_wechat_bind_history", postData, res => {
                    if(res.errcode === 0) {
                        this.listData = res.data;
                        this.page.count = res.count;
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .search-box{
        background-color: #ffffff;
        padding: 16px;
    }
    .list-box{
        background-color: #ffffff;
        padding: 16px;
    }
</style>
